export default __webpack_public_path__ + "static/new-hero-section-image-a48dcfcfbb1800367f277c0f151a8748.jpg";